export default function PhilosophyStatement() {
  return (
    <section className="relative w-full py-24 md:py-32 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          <div className="w-full lg:w-2/5">
            <div className="relative overflow-hidden rounded-3xl aspect-square bg-accent-100">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20wireframe%20geometric%20grid%20floating%20over%20warm%20cream%20gradient%20background%2C%20minimalist%20line%20art%2C%20clean%20diagrammatic%20composition%2C%20no%20people%2C%20no%20text%2C%20architectural%20blueprint%20aesthetic%2C%20soft%20warm%20lighting%2C%20precise%20geometric%20patterns%2C%20subtle%20depth&width=900&height=900&seq=philosophy-statement-technopankai&orientation=squarish"
                alt="Abstract geometric wireframe on warm gradient background"
                title="Technical philosophy and approach"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-3/5 flex flex-col gap-8">
            <div>
              <span className="font-label text-xs tracking-widest uppercase text-secondary-500">(philosophy)</span>
              <h2 className="font-heading text-3xl md:text-5xl font-bold mt-3 leading-tight">
                Continuous<br />
                <span className="text-secondary-400">innovation &amp; evolution</span>
              </h2>
            </div>

            <div className="flex flex-col gap-6">
              <div className="relative">
                <span className="absolute -top-2 -left-2 font-heading text-5xl text-accent-300/40 leading-none">&ldquo;</span>
                <p className="font-body text-base md:text-lg text-foreground-700 leading-relaxed pl-6 pt-2">
                  We believe that great software is never truly finished. Our commitment to continuous improvement means we constantly refine our processes, explore emerging technologies, and push the boundaries of what is possible on the iOS platform. Every project is an opportunity to raise the bar for technical quality and user experience.
                </p>
              </div>
              <div className="flex items-center gap-3 pt-4 border-t border-secondary-200/60">
                <span className="w-8 h-px bg-accent-500"></span>
                <p className="font-body text-sm font-medium text-foreground-950 tracking-wide uppercase">
                  Built to evolve. Engineered to endure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}